import React from 'react';
import Icon from "./Icon";

class Block extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Icon, this.props, /*#__PURE__*/React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 21 20"
    }, /*#__PURE__*/React.createElement("g", {
      id: "icons",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "translate(-554.000000, -357.000000)",
      id: "block"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "translate(552.938977, 355.000000)"
    }, /*#__PURE__*/React.createElement("polygon", {
      id: "Bounds",
      points: "0 0 24 0 24 24 0 24"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M4,12 C4,7.58 7.58,4 12,4 C13.85,4 15.55,4.63 16.9,5.69 L5.69,16.9 C4.63,15.55 4,13.85 4,12 L4,12 Z M12,20 C10.15,20 8.45,19.37 7.1,18.31 L18.31,7.1 C19.37,8.45 20,10.15 20,12 C20,16.42 16.42,20 12,20 L12,20 Z",
      id: "Icon",
      fill: "#FF4E4E"
    }))))));
  }

}

export default Block;